import script from "./BaseTableRowItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTableRowItem.vue?vue&type=script&setup=true&lang=js"

import "./BaseTableRowItem.vue?vue&type=style&index=0&id=1ccd11de&lang=scss&scoped=true"
script.__scopeId = "data-v-1ccd11de"

export default script